import apiClient from "./http";

const rawMeta = { meta: { rawResponse: true } };

export const login = (payload) =>
  apiClient.post("/Auth/login", { payload }, rawMeta);

export const signup = (payload) =>
  apiClient.post("/Auth/signup", { payload }, rawMeta);

export const verifyOtp = (payload) =>
  apiClient.post("/Auth/verify-otp", { payload }, rawMeta);

